var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgImage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  className: "image_svg__svg-safari-fix",
  viewBox: "0 0 24 24",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6m16 0v6.27l-2.055-2.608-.003-.003a1.75 1.75 0 0 0-.555-.47 1.6 1.6 0 0 0-1.5 0c-.225.118-.41.283-.556.47l-3.785 4.803-1.604-2.035a1.75 1.75 0 0 0-.556-.47 1.6 1.6 0 0 0-1.5 0c-.224.119-.41.283-.555.47L5 14.116V6a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1M5 18v-.653l2.636-3.345 1.604 2.034c.146.187.332.352.555.47a1.6 1.6 0 0 0 1.5 0c.224-.118.41-.283.556-.47l3.785-4.803L19 15.501V18a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1m5-10a1 1 0 1 1-2 0 1 1 0 0 1 2 0",
  clipRule: "evenodd"
})));
export default SvgImage;